import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListSocialChallengesV1Request } from './list-social-challenges-v1-request';
import type { IListSocialChallengesV1Response } from './list-social-challenges-v1-response';
import { listSocialChallengesV1ResponseSchema } from './list-social-challenges-v1-response';

export async function listSocialChallengesV1Api({
  query,
  status,
  collectionId,
  minClips,
  maxClips,
  limit,
  offset,
}: IListSocialChallengesV1Request = {}): Promise<
  IValidatedResponse<IListSocialChallengesV1Response>
> {
  return getRequest<IListSocialChallengesV1Response>({
    path: '/sys/social/v1/challenges',
    schema: listSocialChallengesV1ResponseSchema,
    options: { params: { query, status, collectionId, minClips, maxClips, limit, offset } },
  });
}
